// import Keycloak from 'keycloak-js';
// import env from "react-dotenv";
// import { KEYCLOCK_CLIENT, KEYCLOCK_REALM, KEYCLOCK_URL } from '../utils/constants';

// let initOptions = {
//     url: KEYCLOCK_URL,
//     realm:  KEYCLOCK_REALM,
//     clientId: KEYCLOCK_CLIENT,
//     onLoad: 'check-sso',
//     KeycloakResponseType: 'code',
// }

// const kc = new Keycloak(initOptions);

// const initKeycloak = (onAuthenticatedCallback) => {
//     kc.init({
//         onLoad: initOptions.onLoad,
//       }).then((auth) => {
//         if (!auth) {
//             kc.login();
//           } else {
//             onAuthenticatedCallback();
//           }
//       }, () => {
//         onAuthenticatedCallback();
//       });
//   };

// const doLogin = kc.login;

// const doLogout = kc.logout;

// const getToken = () => kc.token;

// const getUserInfo = (userProperty) => kc.tokenParsed?.[userProperty] || null;

// const keycloakTokenParsed = () => kc.tokenParsed

// const getIsAuthenticated = () => kc.authenticated;

// const refreshAccessToken = (sec) => kc.updateToken(sec);

// const keycloakService = {
//   keycloakTokenParsed,
//     initKeycloak,
//     doLogin,
//     doLogout,
//     getToken,
//     getUserInfo,
//     getIsAuthenticated,
//     refreshAccessToken
// }

// export default keycloakService;

import Keycloak from "keycloak-js";
import {
  KEYCLOAK_REDIRECT_URI,
  KEYCLOCK_CLIENT,
  KEYCLOCK_REALM,
  KEYCLOCK_URL,
} from "../utils/constants";
import Cookies from "js-cookie";

const IDLE_TIMEOUT = 60 * 60 * 1000; // 15 minutes inactivity timeout
const CHECK_SESSION_INTERVAL = 25 * 1000; // Check session every 30 seconds
const TOKEN_REFRESH_MARGIN = 30; // Refresh token if it expires within 30 seconds

let sessionCheckTimer;
let idleTimer;
let userActive = false; // Tracks if the user is active

let initOptions = {
  url: KEYCLOCK_URL,
  realm: KEYCLOCK_REALM,
  clientId: KEYCLOCK_CLIENT,
  onLoad: "check-sso",
  KeycloakResponseType: "code",
};

const kc = new Keycloak(initOptions);

/**
 * Check Keycloak session and refresh the token only if the user is active.
 */
const checkSessionStatus = () => {
  if (!kc.authenticated) {
    console.warn("User is not authenticated. Logging out.");

    doLogout();
    return;
  }

  if (kc.isTokenExpired(TOKEN_REFRESH_MARGIN)) {
    if (userActive) {
      kc.updateToken(120)
        .then((refreshed) => {
          if (refreshed) {
            localStorage.setItem("mhet_cnd_token", kc.token);
          } else {
            console.warn("Token refresh failed. Logging out.");
            doLogout();
          }
        })
        .catch(() => {
          doLogout();
        });
    } else {
      console.warn("User inactive. Not refreshing token.");
    }
  }
};

/**
 * Start a timer to check the session periodically.
 */
const startSessionCheck = () => {
  sessionCheckTimer = setInterval(checkSessionStatus, CHECK_SESSION_INTERVAL);
};

/**
 * Reset the inactivity timer on user interaction.
 */
const resetIdleTimer = () => {
  userActive = true;
  clearTimeout(idleTimer);
  idleTimer = setTimeout(() => {
    userActive = false;
    console.warn("User inactive. Logging out due to inactivity.");
    doLogout();
  }, IDLE_TIMEOUT);
};

/**
 * Track user activity for token refresh and inactivity logout.
 */
const trackUserActivity = () => {
  window.addEventListener("mousemove", resetIdleTimer);
  window.addEventListener("keydown", resetIdleTimer);
  window.addEventListener("click", resetIdleTimer);
  window.addEventListener("scroll", resetIdleTimer);
};

/**
 * Initialize Keycloak and start session & activity tracking.
 */
const initKeycloak = (onAuthenticatedCallback) => {
  kc.init({
    onLoad: initOptions.onLoad,
    checkLoginIframe: false,
  })
    .then((auth) => {
      if (!auth) {
        console.warn("No active session found. Redirecting to login...");
        kc.login({
          redirectUri: KEYCLOAK_REDIRECT_URI,
        });
      } else {
        onAuthenticatedCallback();
        startSessionCheck(); // Start session monitoring
        resetIdleTimer(); // Start idle timer
        trackUserActivity(); // Track user activity
      }
    })
    .catch(() => {
      console.error("Authentication failure. Redirecting to login...");
      kc.login({
        redirectUri: KEYCLOAK_REDIRECT_URI,
      });
    });
};

/**
 * Logout user, clear timers, and remove event listeners.
 */
const doLogout = () => {
  clearInterval(sessionCheckTimer);
  clearTimeout(idleTimer);
  window.removeEventListener("mousemove", resetIdleTimer);
  window.removeEventListener("keydown", resetIdleTimer);
  window.removeEventListener("click", resetIdleTimer);
  Cookies.remove("AUTH_SESSION_ID");
  Cookies.remove("AUTH_SESSION_ID_LEGACY");
  Cookies.remove("KEYCLOAK_IDENTITY");
  Cookies.remove("KEYCLOAK_IDENTITY_LEGACY");
  Cookies.remove("KEYCLOAK_SESSION");
  Cookies.remove("KEYCLOAK_SESSION_LEGACY");
  localStorage.removeItem("mhet_cnd_email_verified");
  localStorage.removeItem("mhet_cnd_email");
  localStorage.removeItem("mhet_cnd_mobileno");
  localStorage.removeItem("mhet_cnd_mobileno_otp");
  localStorage.removeItem("mhet_cnd_mobileno_verified");
  localStorage.removeItem("mhet_cnd_project");
  localStorage.removeItem("mhet_mst_token");
  localStorage.removeItem("uploaddetails");
  kc.logout();
};

const doLogin = () =>
  kc.login({
    redirectUri: KEYCLOAK_REDIRECT_URI,
  });

const getToken = () => kc.token;

const getValidToken = async () => {
  try {
    await kc.updateToken(120);
    localStorage.setItem("mhet_cnd_token", kc.token);
    return kc.token;
  } catch (err) {
    console.error("Failed to refresh token", err);
    doLogout();
    return null;
  }
};
const getUserInfo = (userProperty) => {
  const token = kc.tokenParsed;

  if (!token) return null;

  // 1. direct property
  if (token[userProperty]) return token[userProperty];

  // 2. attributes (custom user attributes)
  if (token.attributes && token.attributes[userProperty]) {
    const value = token.attributes[userProperty];
    return Array.isArray(value) ? value[0] : value;
  }

  return null;
};
const keycloakTokenParsed = () => kc.tokenParsed;
const getIsAuthenticated = () => kc.authenticated;

const keycloakService = {
  keycloakTokenParsed,
  initKeycloak,
  doLogin,
  doLogout,
  getToken,
  getUserInfo,
  getIsAuthenticated,
  getValidToken,
};

export default keycloakService;
